// Error codes that mirror the backend constants.py
export const ErrorCode = {
  // Pack line/session errors
  PACK_SESSION_NOT_STARTED: "PACK_SESSION_NOT_STARTED",
  PACK_SESSION_HAS_INCOMPLETE_ROUTES: "PACK_SESSION_HAS_INCOMPLETE_ROUTES",
  PACK_LINE_ON_BREAK: "PACK_LINE_ON_BREAK",
  PACK_LINE_HAS_ENDED: "PACK_LINE_HAS_ENDED",
  PACK_LINE_ID_NOT_FOUND: "PACK_LINE_ID_NOT_FOUND",
  PACK_LINE_QR_CODE_NOT_FOUND: "PACK_LINE_QR_CODE_NOT_FOUND",

  // Delivery errors
  DELIVERY_QR_CODE_NOT_FOUND: "DELIVERY_QR_CODE_NOT_FOUND",
  DELIVERY_CYCLE_MISMATCH: "DELIVERY_CYCLE_MISMATCH",
  DELIVERY_FACILITY_MISMATCH: "DELIVERY_FACILITY_MISMATCH",
} as const;
